<template>
  <v-container id="collection" fluid tag="section">
    <v-row>
      <v-col cols="12" sm="6" lg="3">
        <base-material-stats-card
          color="#095d67"
          icon="mdi-check"
          title="Processed Payments (ITD)"
          value="780"
        />
      </v-col>
      <v-col cols="12" sm="6" lg="3">
        <base-material-stats-card
          color="#0faea0"
          icon="mdi-check"
          title="Total Amount (ITD)"
          value="K69876.00"
        />
      </v-col>
      <v-col cols="12" sm="6" lg="3">
        <base-material-stats-card
          color="#0a7a6e"
          icon="mdi-check"
          title="Avg Weekly (ITD)"
          value="K121"
        />
      </v-col>

      <v-col cols="12" sm="6" lg="3">
        <base-material-stats-card
          color="#0c7d8b"
          icon="mdi-check"
          title="Avg Monthly (ITD)"
          value="K476"
        />
      </v-col>
      <v-col cols="12" md="12">
        <v-row rows="12" align="end" justify="end"> </v-row>
      </v-col>

      <v-col cols="12" md="12">
        <base-material-card color="primary" class="px-5 py-3">
          <template v-slot:heading>
            <div class="display-2 font-weight-dark lightgray--text">
              Repaid Loans History
              <button class="float-right">Download</button>
              <v-spacer />
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                color="lightgray"
              />
            </div>

            <div class="float-right white--text">
              <v-switch
                v-model="singleExpand"
                color="#ffffff"
                label="Single Expand"
                class="mt-2"
              ></v-switch>
            </div>
          </template>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="items"
              :search="search"
              :single-expand="singleExpand"
              :expanded.sync="expanded"
              item-key="id"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              show-expand
              class="elevation-1"
              @click:row="(item, slot) => slot.expand(!slot.isExpanded)"
              @dblclick:row="editItem(item)"
            >
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                  <v-spacer />
                  More info about {{ item.id }}
                  <v-spacer />
                  More info about {{ item.lname }}
                  <v-spacer>
                    More info about {{ item.fname }}
                    <v-spacer />
                    More info about {{ item.organization }}
                  </v-spacer>
                  <v-spacer />
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data: () => ({
    search: "",
    sortBy: "id",
    sortDesc: true,
    expanded: [],
    singleExpand: false,
    headers: [
      {
        sortable: true,
        text: "Date",
        value: "createdAt",
        align: "left",
      },
      {
        sortable: true,
        text: "Name",
        value: "name",
      },
      {
        sortable: true,
        text: "Phone",
        value: "phoneNumber",
      },
      {
        sortable: true,
        text: "Principal(ZMW)",
        value: "loanAmount",
      },
      {
        sortable: true,
        text: "Tenure (Months)",
        value: "tenure",
        align: "center",
      },
      {
        sortable: true,
        text: "Payment Month",
        value: "month",
        align: "center",
      },
      {
        sortable: true,
        text: "Payment Due(ZMW)",
        value: "amountDue",
        align: "right",
      },
      {
        sortable: true,
        text: "Amount Paid",
        value: "amountPaid",
        align: "right",
        class: "font-weight-black",
      },
      { text: "", value: "data-table-expand" },
    ],
    items: [
      {
        id: 1,
        name: "Mwerenga Nicky",
        phone: "260974327259",
        amount: "K200",
        aging: "-2",
        status: "Ovedue",
        dueDate: "2020/12/23",
        date: "2020/12/23",
      },
      {
        id: 2,
        name: "Solomon Leonard",
        phone: "260950637780",
        amount: "K62",
        aging: "29",
        status: "Active",
        dueDate: "2020/03/23",
        date: "2020/02/23",
      },
      {
        id: 3,
        name: "Saunda Benard",
        phone: "26095929292",
        amount: "K8932",
        aging: "30",
        status: "Active",
        dueDate: "2021/04/28",
        date: "2021/03/28",
      },
      {
        id: 4,
        name: "Nyawela Patrick",
        phone: "26096728273",
        amount: "K1000",
        aging: "-2",
        status: "Ovedue",
        dueDate: "2021/03/08",
        date: "2021/02/08",
      },
      {
        id: 5,
        name: "Sekerere Ronny",
        phone: "26077826372",
        amount: "K700",
        aging: "-8",
        status: "Ovedue",
        dueDate: "2020/02/01",
        date: "2020/02/01",
      },
      {
        id: 6,
        name: "Solomon Leonard",
        phone: "26075102912",
        amount: "K12",
        aging: "0",
        status: "Settled",
        dueDate: "2021/04/14",
        date: "2021/03/14",
      },
    ],
  }),
  mounted() {
    document.title = 'Settled Loans | Kredwise'
  },
};
</script>

<style lang="scss" scoped></style>
